import type { CSSInterpolation } from '@emotion/serialize';

import { BuildType } from '../../../src/enums/build/build-type';
import { fonts } from '../../../src/styling/constants';

export type Fonts = {
  light: CSSInterpolation;
  regular: CSSInterpolation;
  bold: CSSInterpolation;
};

export const getFonts = (buildType: BuildType): Fonts => {
  const defaultFont: Fonts = {
    light: fonts.light,
    regular: fonts.regular,
    bold: fonts.bold,
  };

  switch (buildType) {
    case BuildType.HARBOUR:
      return {
        light: fonts.harbourLight,
        regular: fonts.harbourLight,
        bold: fonts.harbourBold,
      };
    default:
      return defaultFont;
  }
};
